var Exigo = {
  Settings: {
    ShopUrl: "a79943-2.myshopify.com",
    ApiUrl: "https://kleokolorshopifyplugin.azurewebsites.net",
    BackofficeUrl: "https://kleosuite.kleokolor.com",
    SilentLoginUrl: "/account/silentlogin?token=",
    StorePublicUrl: "https://kleokolor.myshopify.com",//"https://www.kleokolor.com",
    CheckoutUrl: "",//"https://localhost:44348",
    DebugCheckoutUrl: "https://localhost:44348",
    DebugApiUrl: "https://localhost:44341",
    ReferralCookieName: "refId",
    LoginCookie: "ExigoSilentLogin",
    SyncCookie: "ExigoCustomerSyncing",
    ReferralParameter: "ref",
    DefaultWebalias: "CorpOrphan",
    EnableEnrollerSearch: true,
    RetailCustomerType: 1,
    HasParty: true,
    AffiliatePoints: {
      UseAffiliatePoints: true,
    },
    Enrollment:{
      Enable: true,
      ForceEnrollmentFlow: true
    }
  },
  Actions: {
    SetEnrollerSearch: function() {
      setEnrollerSearch();
    },
    AddReferralToUrl: function() {
      addReferralToUrl();
    },
    SearchForEnroller: function(query){
      searchForEnroller(query);
    },
    Checkout: {
      GetProductPrices: function(priceType, sku){
        getProductPrices(priceType, sku);
      },
      CalculateCart: function(priceType, cartType) {
        calculateCart(priceType, cartType);
      }
    },
    AffiliatePoints: {
      GetPoints: function(callback){
        getPoints(callback);
      },
      SpendPoints: function(value){
        addPointsToCart(value);
      },
      GetEligibleRewards: function(callback){
        getEligibleRewards(callback);
      },
      GetAllEligibleRewards: function(callback){
        getAllEligibleRewards(callback);
      },
      GetAllAffiliateRewards: function(callback){
        getAllAffiliateRewards(callback);
      },
      CreateAffiliateReward: function(callback, id){
        createAffiliateReward(callback, id);
      }
    }
  },
  Initialize: function(){
    initialize();
  }
}
Exigo.Initialize();


//Basic Functions
var exigoSilentLoginToken;
var storePublicUrl;
var silentLoginUrl;
var backofficeUrl;
var silentLoginUrl;
var referralCookieName;
var loginCookie;
var syncCookie = "ExigoCustomerSyncing";
var referralParameter;
var apiUrl;
var priceType = 1;
var priceTypeWithCurrency;
var isDebug = 0;
var checkoutUrl;
var debugCheckoutUrl;
var shopUrl;
var defaultWebalias;
var debugApiUrl;
var enableEnrollerSearch;
var useCheckout;
var useEnrollment;
var forceEnrollmentFlow;
var useCheckoutForEnrollment;
var useCheckoutForSubscriptions;
var cartFormId;
var clearCartbyParameter;
var hasClearCartShopifyPage;
var restrictEnrollmentKits;
var enrollmentKitsAllowed;
var currentLocationNoRef;
var pointsAvailable;
var oldCookieRef;
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return Exigo.Settings.DefaultWebalias;
}
function setEnroller() {
  var referral = getCookie(referralCookieName).toLowerCase()
  fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: { "Referral": referral } }),
  });
}
function addReferralToUrl() {
  var refId = (isCustomer && (exigoCustomerTypeId == 3 ||  exigoCustomerTypeId == 2)) ? exigoWebalias : (isCustomer && exigoCustomerTypeId == 1 && _referral != defaultWebalias) ? _referral : getCookie(referralCookieName);
  var links = document.querySelectorAll("a");
  for (var i = 0; i < links.length; i++) {
      var link = links[i].getAttribute("href");
      if (link != null && !link.includes("mailto")) {
        var href = removeURLParameter(link, referralParameter)
        links[i].href = addUrlParameter(href, referralParameter + "=" + refId);
        var partyId = getUrlVars()["partyid"]
        if(partyId != undefined) {
          links[i].href = links[i].href + "&partyid=" + partyId;
        }
      }
  }
}
function setReferralCookie() {
  var ref = getCookie(referralCookieName);
  var urlRef = getUrlVars()[referralParameter];
  var original = getUrlVars()["original"];
  var yotpo = getUrlVars()["sref_id"];
  if(urlRef != undefined && urlRef != ref) {
    ref = urlRef;
  }
  if(urlRef == undefined && yotpo != undefined) {
    if(isCustomer && (exigoCustomerTypeId == 3 || exigoCustomerTypeId == 2))
    {
      
      $(".yotpo-ok-button").on("click", function(){
          window.location = "/";
      });
      $("#exigo-yotpo-modal-title").html("Not allowed");
      $("#exigo-yotpo-modal-body").html("As a brand partner you cannot shop from a Yotpo referral link!");
      openModal("#yotpo-alert-modal",false);
    }
    else
    {
      $.ajax({
        url: apiUrl + '/api/customer/GetYotpoReferral?id=' + yotpo + "&shopUrl=" + shopUrl,
        type: "GET",
        success: function(response){
          console.log(response);
          ref = response;
          
          if (ref != getCookie(referralCookieName) && ref.toLowerCase() != defaultWebalias.toLowerCase()) {
              var expires = "";
              var date = new Date();
              date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toUTCString();
              document.cookie = referralCookieName + "=" + ref + expires + "; path=/";
          }
          if (ref.toLowerCase() == defaultWebalias.toLowerCase() && original != undefined) {
              var expires = "";
              var date = new Date();
              date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toUTCString();
              document.cookie = referralCookieName + "=" + ref + expires + "; path=/";
          }
        }
      });
    }
  }
  ref = ref.replace("?ref", "");
  ref = ref.replace("/", "");
  ref = ref.replace("$partyid", "");
  ref = ref.replace("elizabethchadwick", "BethChadwick");
  ref = ref.replace("Nina%27sNailNation", "NinasNailNation");
  
  if(isCustomer)
  {
    ref = (exigoCustomerTypeId == 3 || exigoCustomerTypeId == 2) ? exigoWebalias : (exigoCustomerTypeId == 1 && _referral != "CorpOrphan") ? _referral : ref;
  }
  if (ref != getCookie(referralCookieName) && ref.toLowerCase() != defaultWebalias.toLowerCase()) {
      var expires = "";
      var date = new Date();
      date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
      document.cookie = referralCookieName + "=" + ref + expires + "; path=/";
  }
  if (ref.toLowerCase() == defaultWebalias.toLowerCase() && original != undefined) {
      var expires = "";
      var date = new Date();
      date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
      document.cookie = referralCookieName + "=" + ref + expires + "; path=/";
  }
}
function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.toLowerCase().slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
function setEnrollerSearchLogic() {
  $('[data-role="search-enroller"]').on("click", function(){
    $(".enroller-search-container").show();
    $(".enroller-box").hide();
  });
  $(window).click(function() {
    $('#enrollerSearchResult').hide();
  });
  $('#searchEnrollerInput').on("focus", function(event){
    if($(this).val() != "")
    {
      $('#enrollerSearchResult').show();
    }
  });
  $('#searchEnrollerInput').click(function(event){
    event.stopPropagation();
  });
  $('#enrollerSearchResult').click(function(event){
    event.stopPropagation();
  });
  
  $('#searchEnrollerInput').keyup(delay(function (e) {
    var query = $(this).val();
    if(query == "") {
      $("#enrollerSearchResult").hide();
    } else {
      searchForEnroller(query);
    }
  }, 500));
  var enrollersearch = document.getElementById("enrollerSearch")
  if(enrollersearch != undefined) {
      $.ajax({
        url: apiUrl + '/api/context/GetEnroller?webalias=' + getCookie(referralCookieName) + "&shopUrl=" + shopUrl,
        type: "GET",
        success: function(response){
            var source = document.getElementById("enroller-id-template").innerHTML;
            var template = Handlebars.compile(source);
            $("#enrollerInfo").html(template(response));
        }
      });
  }
}
function getEnroller(callback) {
  var referral = getCookie(referralCookieName);
  if(referral != undefined) {
    $.ajax({
      url: apiUrl + '/api/context/GetEnroller?webalias=' + getCookie(referralCookieName) + "&shopUrl=" + shopUrl,
      type: "GET",
      success: function(response){
        callback(response);
      },
      error: function(error){
        //if(getCookie(referralCookieName) != defaultWebalias) {
          //alert("The referral id used is not found in our database. Please search for your referral!\n\nIf this is not correct, reach out to customer care with info below:\n\nUrl: " + 
                //location.href + "\nReferralId: " + getCookie(referralCookieName) + "\nBrowser: " + navigator.userAgent+ "\nError: " + error.responseText);
          //var expires = "";
          //var date = new Date();
          //date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
          //expires = "; expires=" + date.toUTCString();
          //document.cookie = referralCookieName + "=" + defaultWebalias + expires + "; path=/";
          //var url = location.href.toLowerCase().replace(getUrlVars()[referralParameter].toLowerCase(), defaultWebalias)
          //window.location = url;
        //}
      }
    });
  }
}
function searchForEnroller(query){
  setTimeout(function(){
    $("#enrollerSearchResult").show();
    var currentWebalias = getCookie("refId");
    console.log(currentWebalias);
    $.ajax({
      url: apiUrl + '/api/context/EnrollerSearch?query=' + query + "&shopUrl=" + shopUrl,
      type: "GET",
      success: function(response){
        if(response.length == 0) {
          $("#enrollerSearchResult").html('<span class="enroller-no-result">No Referrals Found</span>');
        } else {
          var source = document.getElementById("search-result-template").innerHTML;
          var html= "";
          $.each(response, function(i,item){
            console.log(item);
            var url = "";
            if(location.href.includes("ref=")) {
              url = location.href.replace(currentWebalias, item.webAlias);
            } else {
              url = location.href + "?ref=" + item.webAlias;
            }
            item["link"] = url;
          });
          var template = Handlebars.compile(source);
          $("#enrollerSearchResult").html(template(response));
        }
      }
    });
  }, 500);
}
function setCookie(cName, value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = cName + "=" + value + expires + "; path=/";
}
function addUrlParameter(url, param) {
  var firstLetter = Array.from(url)[0];
  if(firstLetter != "#") {
    if (url != null && url.includes("?")) {
        url = url + '&';
    } else {
        url = url + '?';
    }
    url = url + param;
  }
  return url;
}
function insertNotesCreateCustomerForm() {
    var form = document.getElementById("create_customer");
    if (form != undefined) {
        var refId = getCookie(referralCookieName);
        var refInput = document.createElement("input");
        refInput.setAttribute("type", "hidden");
        refInput.setAttribute("name", "customer[note][referral]");
        refInput.setAttribute("value", refId);
        form.prepend(refInput);
        $("#redirect").val("/account" + window.location.search);
    }
}
function insertNotesLoginForm() {
    var form = document.getElementById("customer_login");
    if (form != undefined) {
        $("#redirect").val("/account" + window.location.search);
    }
}
function setDebugCookie() {
    var debug = getUrlVars()["debugsession"];
    if (debug != null) {
        setCookie("debugsession", debug);
    } else {
        var debugCookie = getCookie("debugsession");
        if (debugCookie == "") {
            setCookie("debugsession", "0");
        }
    }
}
function removeURLParameter(url, parameter) {
    if (url != null) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);
            for (var i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }
}
function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}
function setDebug(){
    isDebug = getCookie("debugsession");
    if (isDebug == "1") {
      apiUrl = debugApiUrl;
    }
}

function setPartyCookie() {
  var partyId = getPartyCookie("partyId");
  var urlparty = getUrlVars()["partyid"];
  if(urlparty != undefined && urlparty != partyId) {
    partyId = urlparty;
  }
  if (partyId != getPartyCookie() && partyId != "0") {
      document.cookie = "partyId=" + partyId + "; path=/";
  }
}
function getPartyCookie() {
  let name = "partyId=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "0";
}
function setEnrollerSearch() {
  var referral = getCookie(referralCookieName).toLowerCase();
  var partyId = getPartyCookie();
  var attributesData = {
    Referral: referral
  }
  if(partyId != "0") {
    var array = partyId.split(/[/?]/);
    attributesData.PartyId = array[0];
  }
  if (referral != defaultWebalias.toLowerCase()) {
      fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes: attributesData }),
      });
  }
}
function setEventListeners(){
  $(".silentlogin").on("click", function(e){
    console.log("clicked");
    $(this).html("Redirecting...");
    logIn();
  });
}
function getLoginCookie() {
    let name = loginCookie + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function setLoginCookie(value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (25 * 60 * 1000000));
    expires = "; expires=" + date;
    document.cookie = loginCookie + "=" + value + expires + "; path=/";
}
function deleteLoginCookie() {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() - (25 * 60 * 10000000));
    expires = "; expires=" + date;
    document.cookie = loginCookie + "=" + expires + "; path=/";
}
function logIn(){
    if(isCustomer){
      console.log("Logging in");
      var data = {
        shopId: customerId,
        sharedKey: "yudygusydgfasdyfgoew87ry384gr837g"
      }
      $.ajax({
        url: apiUrl + '/api/authentication/RefreshAdminLoginToken',
        type: "GET",
        data: data,
        success: function(response){
          console.log(response);
          window.location = backofficeUrl + "/silentlogin?token=" + response;
        }
      });
    }
}
function refreshLoginCookie(){
  if(isCustomer){
    const tokenRefreshed = new Event('tokenRefreshed');
    var token = "";
    if(token == ""){
      var data = {
        shopId: customerId,
        sharedKey: "yudygusydgfasdyfgoew87ry384gr837g"
      }
      $.ajax({
        url: apiUrl + '/api/authentication/RefreshAdminLoginToken',
        type: "GET",
        data: data,
        success: function(response){
          token = response;
          setLoginCookie(response);
          window.dispatchEvent(tokenRefreshed);
          $(".silentlogin").each(function(){
              href = backofficeUrl + "/silentlogin?token=" + token;
              $(this).attr("href", href);
              //$(this).show();
          })
        }
      });
    } else {
      var data = {
        shopUrl: shopUrl,
        token: token
      }
      $.ajax({
        url: apiUrl + '/api/authentication/ValidateToken',
        type: "GET",
        data: data,
        success: function(response){
          if(response) {
            window.dispatchEvent(tokenRefreshed);
            $(".silentlogin").each(function(){
                href = backofficeUrl + "/silentlogin?token=" + token;
                $(this).attr("href", href);
                //$(this).show();
            })
          } 
        },
        error: function(){
            setLoginCookie("");
        }
      });
    }
  } else{
      setLoginCookie("");
  }
}
function setSyncCookie(value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (25 * 60 * 1000000));
    expires = "; expires=" + date;
    document.cookie = syncCookie + "=" + value + expires + "; path=/";
}
function getSyncCookie() {
    let name = syncCookie + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function syncCustomer(){
  if(isCustomer && exigoId < 1 && getSyncCookie() != customerId){
    setSyncCookie(customerId);
    exigoId = -1;
    var data = {
      Id: customerId,
      exigoId: exigoId,
      customerTypeId: exigoCustomerTypeId,
      webalias: exigoWebalias,
      currentWebalias: getCookie(referralCookieName),
      currentReferral: _referral
    }
    $.ajax({
      url: apiUrl + '/api/context/CreateCustomer',
      type: "GET",
      data: data,
      success: function(response){
        console.log(response);
        refreshLoginCookie();
        if(response.value.exigoCustomerTypeId > 1){
          console.log("Show Kleo Portal Button");
          $(".silentlogin").show();
        }
        if(response.value.portalUrl != ""){
          $(".portalUrl").attr("href", response.value.portalUrl);
        }
      }
    });
  }
}
function syncCustomerData(){
  console.log("Syncing Customer");
  if(isCustomer && exigoId > 0){
    var data = {
      Id: customerId,
      exigoId: exigoId,
      customerTypeId: exigoCustomerTypeId,
      webalias: exigoWebalias,
      currentWebalias: getCookie(referralCookieName),
      currentReferral: _referral
    }
    $.ajax({
      url: apiUrl + '/api/context/SyncCustomer',
      type: "GET",
      data: data,
      success: function(response){
        console.log(response);
        refreshLoginCookie();
        if(response.value.exigoCustomerTypeId > 1){
          console.log("Show Kleo Portal Button");
          $(".silentlogin").show();
        }
        if(response.value.portalUrl != ""){
          $(".portalUrl").attr("href", response.value.portalUrl);
        }
      }
    });
  }
}
function createShareCartLink(){
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      var url = storePublicUrl +"/cart/"; //"https://" + shopUrl + "/cart/";
      for(let i = 0; i < json.items.length; i++) {
        if(json.items[i].discounts.length == 0){
          url = url + json.items[i].variant_id;
          url = url + ":" + json.items[i].quantity;
          if(i < (json.items.length - 1)){
            url = url + ","
          }
        } else if (json.items[i].discounts[0].title != "FREE-LAMP") {
          url = url + json.items[i].variant_id;
          url = url + ":" + json.items[i].quantity;
          if(i < (json.items.length - 1)){
            url = url + ","
          }
        }
      }
      url = url + "?storefront=true";
      if(isCustomer){
        url = url + "&ref=" + exigoWebalias;
      }
      try {
        copy(url);
      } catch (err) {
        alert('Failed to copy!', err);
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}

function createShareCartLink2(){
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      var debugParam = "";
      if(getCookie("debugsession") == "3"){
        debugParam = "&debugsession=3";
      }
        
      $.ajax({
          type: 'POST',
          url: apiUrl + '/api/SharedCart/AddSharedCartToShopifyId?externalCustomerId=' + customerId + "&shopUrl=" + shopUrl,
          contentType: "application/json",
          data: JSON.stringify(json) ,
          success: function(result) {
            var urlHost = "https://" + window.location.host;
            var urlPath = "?cart=" + result + "&ref=" + getCookie(referralCookieName) + debugParam;
            var noneEncodedUrl = urlHost + urlPath;
            var encodedUrl = encodeURIComponent(urlPath);
            $("#carturl").val(noneEncodedUrl);
            $(".sharecart-facebook").attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + urlHost + encodedUrl);
            openModal("#sharecart-modal", true);
            Rebuy.SmartCart.hide();
          }
      });
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function getCartCookie() {
  let name = "CartCopied=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
}
async function GetCart(key) {
    var cartCopied = getCartCookie();
    if(cartCopied == undefined) {
        document.cookie = "CartCopied=" + key + "; path=/";
        
        try {

            const response = await fetch(apiUrl + '/api/SharedCart/GetSharedCartData?key=' + key + "&shopUrl=" + shopUrl);
            const cart = await response.json();

            const items = [];

            // Clear existing cart first
            await $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                dataType: 'json'
            });

            // Process all items in a single loop
            for (const item of cart.items) {
                if(item.discounts.length > 0 && item.discounts[0].title === "FREE-LAMP") {
                    continue;
                }

                // If it's not a bunlde add to cart
                if(item.variant_id != 49612340101424) {
                    // Add regular items
                    items.push({
                        id: item.variant_id,
                        quantity: item.quantity,
                        properties: item.properties || {}
                    });
                }
            }

            // Add remaining items
            if(items.length > 0) {
                await $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: { items }
                });
            }

            return cart;

        } catch (error) {
            console.error('Error processing cart:', error);
            throw error;
        }
    }
}
function createCart(key){
  GetCart(key).then(cart => {
  });
}
function copy(text) {
    return new Promise((resolve, reject) => {   
        navigator.clipboard.writeText(text).then(() => {
          $("#cart-link-copied").show();
          $(".cart-link-copied").show();
          setTimeout(function() {
            $("#cart-link-copied").fadeOut(500);
            $(".cart-link-copied").fadeOut(500);
          }, 2000);
        }).catch(function (error) {
          $("#cart-url").val(text);
          $("#cart-url").show();
          $(".copy-cart-link").show();
          $(".share-cart-link").hide();
          alert("Cart url generated. Please click the copy link button to copy to your clipboard");
        });
    });
}


async function fetchCart() {
    var response = await fetch('/cart.js');
    return await response.json();
  }
async function forceEnrollment(){
  var enrollmentStep = $("#enrollment-flow-step").val();
  if(enrollmentStep == undefined){
    if(!location.href.includes("challenge")) {
      var cart = await fetchCart();
      if (cart.attributes.CustomerType != undefined) {
        var selection = confirm("Moving out of the enrollment will clear your cart");
        if(selection) {
          clearEnrollmentFlow(window.location.href);
        } else {
          window.location = history.back();
        }
      }
    }
  }
}
function clearEnrollmentFlow(url){
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function(){
      var nullHash = {
          'Birthday': null,
          'Webalias': null,
          'CustomerType': null,
          'Email': null
      };
      $.ajax({
          type: "POST",
          url: '/cart/update.js',
          data: {attributes:nullHash},
          dataType: 'json',
          success: function(){
            if(url == undefined){
              return;
            } else {
              var original = getUrlVars()["original"];
              if(original != undefined){
                url = url.replace(getUrlVars()["ref"], getUrlVars()["original"]);
              }
              window.location = url;
            }
          }
      });
    },
      dataType: 'json'
    
    });
  }
  //Modal logic
function openModal(id, closeOutsideClick) {
    $(id).css("display", "block");
    if(closeOutsideClick === true) {
      $(document).on('click', function(event) {
        if ($(event.target).attr('class') == "exigo-modal-dialog" || $(event.target).attr('class') == "exigo-modal") {
            $(id).css("display", "none");
        }
      });
    }
  }
  //end modal logic
function setSettings(){
    apiUrl = Exigo.Settings.ApiUrl;
    checkoutUrl = Exigo.Settings.CheckoutUrl;
    shopUrl = Exigo.Settings.ShopUrl;
    storePublicUrl = Exigo.Settings.StorePublicUrl;
    debugApiUrl = Exigo.Settings.DebugApiUrl;
    hasParty = Exigo.Settings.HasParty;
    debugCheckoutUrl = Exigo.Settings.DebugCheckoutUrl;
    backofficeUrl = Exigo.Settings.BackofficeUrl;
    loginCookie = Exigo.Settings.LoginCookie;
    syncCookie = Exigo.Settings.SyncCookie;
    silentLoginUrl = (Exigo.Settings.SilentLoginUrl == undefined);
    referralCookieName = (Exigo.Settings.ReferralCookieName == undefined) ? "refid" : Exigo.Settings.ReferralCookieName;
    referralParameter = (Exigo.Settings.ReferralParameter == undefined) ? "ref" : Exigo.Settings.ReferralParameter;
    defaultWebalias = (Exigo.Settings.DefaultWebalias == undefined) ? "CorpOrphan" : Exigo.Settings.DefaultWebalias;
    enableEnrollerSearch = (Exigo.Settings.EnableEnrollerSearch == undefined) ? false : Exigo.Settings.EnableEnrollerSearch;
    if(Exigo.Settings.Checkout != undefined){
      useCheckout = (Exigo.Settings.Checkout.UseCheckout == undefined) ? false : Exigo.Settings.Checkout.UseCheckout;
      if(useCheckout)
      {
        cartFormId = (Exigo.Settings.Checkout.CartFormId == undefined) ? "cart" : Exigo.Settings.Checkout.CartFormId;
        clearCartbyParameter = (Exigo.Settings.Checkout.ClearCartbyParameter == undefined) ? false : Exigo.Settings.Checkout.ClearCartbyParameter;
        hasClearCartShopifyPage = (Exigo.Settings.Checkout.HasClearCartShopifyPage == undefined) ? false : Exigo.Settings.Checkout.HasClearCartShopifyPage;
        restrictEnrollmentKits = (Exigo.Settings.Checkout.RestrictEnrollmentKits == undefined) ? false : Exigo.Settings.Checkout.RestrictEnrollmentKits;
        enrollmentKitsAllowed = (Exigo.Settings.Checkout.EnrollmentKitsAllowed == undefined) ? false : Exigo.Settings.Checkout.EnrollmentKitsAllowed;
        useCheckoutForEnrollment = (Exigo.Settings.Checkout.UseCheckoutForEnrollment == undefined) ? false : Exigo.Settings.Checkout.UseCheckoutForEnrollment;
        useCheckoutForSubscriptions = (Exigo.Settings.Checkout.UseCheckoutForSubscriptions == undefined) ? false : Exigo.Settings.Checkout.UseCheckoutForSubscriptions;
      }
    }
  if(Exigo.Settings.Enrollment != undefined){
      useEnrollment = (Exigo.Settings.Enrollment.Enable == undefined) ? false : Exigo.Settings.Enrollment.Enable;
      if(useEnrollment)
      {
        forceEnrollmentFlow = (Exigo.Settings.Enrollment.ForceEnrollmentFlow == undefined) ? false : Exigo.Settings.Enrollment.ForceEnrollmentFlow;
      }
    }
}
async function initializeShareCart() {
   if(isCustomer && (exigoCustomerTypeId == 3 || exigoCustomerTypeId == 2)){
    $(".share-cart-link").on("click", function(){
        createShareCartLink2();
    });
    $(".copy-cart-link").on("click", function(){
      var text = $("#cart-url").val();
      copy(text);
    });
     $("#sharecart-link").on("click", function(){
      var text = $("#carturl").val();
      const tooltip = document.getElementById('tooltip');
      return new Promise((resolve, reject) => {   
        navigator.clipboard.writeText(text).then(() => {
          tooltip.classList.add('show');
          setTimeout(() => {
              tooltip.classList.remove('show');
          }, 2000);
        }).catch(function (error) {
          tooltip.html('Failed to copy link');
          setTimeout(() => {
              tooltip.classList.remove('show');
          }, 2000);
        });
    });
    });
   } else {
     $(".share-cart-link").hide();
   }
}
function runScript()
{
  var url = location.href;
  var run = true;
  if(url.includes("/tools/") || url.includes("/apps/") || url.includes("/a/") || url.includes("/community/"))
  {
     run = false;
  }
  return run;
}
function initialize(){
  if(runScript())
  {
    console.log("%cExigo Script Running...", "color:green")
    document.addEventListener("DOMContentLoaded", function (e) {
      setSettings();
      setDebugCookie();
      setDebug();
      syncCustomer();
      syncCustomerData();
      setReferralCookie();
      setPartyCookie();
      setEnroller();
      currentLocationNoRef = removeURLParameter(location.href, referralParameter);
      addReferralToUrl();
      insertNotesCreateCustomerForm();
      insertNotesLoginForm();
      setEnrollerSearchLogic();
      setEnrollerSearch();
      setCartEnrollerSearch();
      setEventListeners();
      if(useEnrollment){
        if(forceEnrollmentFlow){
          forceEnrollment();
        }
      }
      if(hasParty) {
        InitializeParty();
      }
      if(enableEnrollerSearch){
        setEnrollerSearch();
      }
      if(useCheckout)
      {
        setCheckoutEventListeners();
        clearCartLogic();
      }
      setTimeout(function() {
        logCart();
        initializeShareCart();
      }, 3000);
       if(getUrlVars()["cart"] != undefined){
        createCart(getUrlVars()["cart"]);
       } else {
         document.cookie = 'CartCopied=; Max-Age=0; path=/;';
       }
    });
  }
  else
  {
    console.log("%cExigo Scripts not running, visting proxy page", "color:red");
    $("#cartEnrollerSearch").css("style","display:none");
  }
}
function logCart() {
    return fetch('/cart.js')
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
          console.log(json);
        })
        .catch(function (error) {
            console.error('Error retreiving cart: ', error);
            return "";
        });
}
function webaliasAwailable(callBack, webAlias){
  $.ajax({
    url: apiUrl + '/api/Customer/IsWebaliasAvailable?Webalias=' + webAlias + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function emailAvailable(callBack, email){
  $.ajax({
    url: apiUrl + '/api/Customer/IsEmailAvailable?email=' + email + '&shopUrl=' + shopUrl + "&checkShopify=true",
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      console.log(response);
      callBack(response);
    }
  });
}
function createCustomerShopify(callBack, data){
  $.ajax({
    url: apiUrl + '/api/customer/CreateCustomerInShopify?shopUrl=' + shopUrl,
    type: "POST",
    data: JSON.stringify(data), 
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function loginCustomer(callBack, data){
  $.ajax({
    url: "/account/login",
    type: "POST",
    data: data.serialize(), 
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
//End Basic Functions

//Exigo Checkout Functions
var orderTotalNew = 0;
var autoOrderTotalNew = 0;
async function getCartJsonString(){
  const cart = await fetch('/cart.js');
  const json = await cart.json();
  json.items.map(function(item) { 
      delete item.product_description; 
      return item; 
  });
  return json;        
}
function setPrices(){
  hasPack = false;
  hasSubscription = false;
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      for(let i = 0; i < json.items.length; i++) {
        let obj = json.items[i];
        if(obj.properties != null) {
          if(obj.properties.ordertype == "enrollmentpack"){
            hasPack = true;
          } else if(obj.properties.ordertype == "autoorder"){
            hasSubscription = true;
          }
        }
      }
      if(hasSubscription && !hasPack){
        priceType = 2;
        priceTypeWithCurrency = priceType + "_" + currencyCode;
        getProductPrices();
      } else if (hasPack){
        priceType = 3;
        priceTypeWithCurrency = priceType + "_" + currencyCode;
        getProductPrices();
      }
      calculateCart();
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function GoToCheckout() {
  hasPack = false;
  hasSubscription = false;
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      for(let i = 0; i < json.items.length; i++) {
        let obj = json.items[i];
        if(obj.properties != null) {
          if(obj.properties.ordertype == "enrollmentpack"){
            hasPack = true;
          }
          if(obj.properties.ordertype == "autoorder"){
            hasSubscription = true;
          }
        }
      }
      var referral = getCookie(referralCookieName);
      if(useCheckoutForEnrollment && hasPack) {
        getCartJSON();
      } else {
        window.location = "/checkout";
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function createDiscountedShopifyCheckout() {
    return fetch('/cart.js')
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
          json.items.map(function(item) { 
              delete item.product_description; 
              return item; 
          });
          var referral = getCookie(referralCookieName);
          var jsonstring = JSON.stringify(json);
          var cart = jsonstring.replace("'s", "s");
          var data = {
              Cart: JSON.stringify(json),
              Country: countryCode,
              Token: exigoSilentLoginToken,
              ShopUrl: Exigo.Settings.ShopUrl,
              CustomerId: customerId,
              CustomerTypeId: customerType,
              PointAccountId: pointAccountId
            };
          console.log(data);
          $.ajax({
            url: apiUrl + '/api/shopping/createDraftOrder',
            type: "POST", 
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            success: function(response){
              window.location = response;
            }
          });
        })
        .catch(function (error) {
            console.error('Error retreiving cart: ', error);
            return "";
        });
}
function getCartJSON() {
    return fetch('/cart.js')
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
          json.items.map(function(item) { 
              delete item.product_description; 
              delete item.title;
              delete item.featured_image.alt;
              item.product_title = item.product_title.replace(/"|'/g,'');
              return item; 
          });
          var referral = getCookie(referralCookieName);
          var url = checkoutUrl + '/' + referral;
          console.log(json);
          var form = $('<form action="' + url + '" method="post">' +
            "<input type='text' name='token' value='" + getLoginCookie() + "' />" +
            "<input type='text' name='cart' value='" + JSON.stringify(json) + "' />" +
            '<input type="text" name="countryCode" value="' + countryCode + '" />' +
            '<input type="text" name="shopUrl" value="' + Exigo.Settings.ShopUrl + '" />' +
            '<input type="text" name="cultureCode" value="' + cultureCode + '" />' +
            '</form>');
          $('body').append(form);
          form.submit();
        })
        .catch(function (error) {
            console.error('Error retreiving cart: ', error);
            return "";
        });
}
function getProductPrices() {
  $(".exigo-price").each(function(){
    var sku = $(this).data("sku");
    $.ajax({
      url: apiUrl + '/api/context/getProductPrice?pricetype=' + priceTypeWithCurrency + '&sku=' + sku + '&shopUrl=' + shopUrl,
      type: "GET",
      success: function(response){
        $(".exigo-product-price-" + sku).html("$" + response.price);
        $(".preferred-product-price-" + sku).html("$" + response.preferredPrice);
        $(".wholesale-product-price-" + sku).html("$" + response.wholesale);
        $(".retail-product-price-" + sku).html("$" + response.retail);
        $(".cv-" + sku).html("$" + response.cv);
        $(".bv-" + sku).html("$" + response.bv);
        $(".qv-" + sku).html("$" + response.qv);
      }
    });
  });
  if(priceType > 1){
    $(".Price--compareAt").show();
  }
}
async function calculateCart() {
  var exigoCart = $("#exigo-cart");
  if(exigoCart != undefined){
    if(priceType > 1) {
      const cart = await getCartJsonString();
      orderTotalNew = 0;
      var points = cart.attributes.points;
      if(points != undefined) {
        orderTotalNew = -points;
      }
      for(var i in cart.items){
        var item = cart.items[i];
        if(item.selling_plan_allocation == undefined) {
          setCartPrice(item); 
        }
      }
      $(".additional-checkout-buttons").hide();
      $("#paypal-animation-container").hide();
    }
  }
}
function setCartPrice(item){ 
  $.ajax({
    url: apiUrl + '/api/context/calculateCartItem?pricetype=' + priceTypeWithCurrency + "&sku=" + item.sku + "&quantity=" + item.quantity + '&shopUrl=' + shopUrl,
    type: "GET",
    success: function(response){
      orderTotalNew = orderTotalNew + response.finalPrice;
      $(".exigo-price-" + item.sku).html("$" + response.price);
      $(".exigo-cart-finalprice-" + item.sku).html("$" + response.finalPrice.toFixed(2));
      $(".exigo-cart-total").html("$" + orderTotalNew.toFixed(2));
      if(pointsAvailable > 0 && pointsAvailable >= orderTotalNew){
        $("#exigo-pointstospend").attr({
           "max" : orderTotalNew
        });
      } else {
        $("#exigo-pointstospend").attr({
           "max" : pointsAvailable
        });
      }
    }
  });
}
function clearCartLogic(){
  if(Exigo.Settings.Checkout. ClearCartbyParameter && window.location.href.includes("clearcart=true")) {
    clearCart();
    window.location = window.location.href.replace("clearcart=true", "");
  }
  if(Exigo.Settings.Checkout.HasClearCartShopifyPage && window.location.href.includes("pages/clearcart")){
    clearCart();
    window.location = appUrl + "/" + getCookie(cookieName) + "/shopifycheckout/ordercomplete";
  }
}
function setCheckoutEventListeners(){
  $('#' + cartFormId).on("submit", function (e) {
      e.preventDefault();
      GoToCheckout();
  });
  $('[data-role="add-to-order"]').on("click", function (e) {
    var orderType = $("#ordertype").val();
    if(orderType == "enrollmentpack"){
      Checkforenrollmentkit(this);
    } else {
      addToCart(this);
    }
  });
  $('[data-role="remove-kit"').on("click", function(){
    clearCart();
  });
  $('input[name="exigo-ordertype"]').on("change", function(){
    var orderType = $("input[name='exigo-ordertype']:checked").val();
    $("#ordertype").val(orderType);
    if(orderType == "autoorder") {
      $("#autoorderFrequencySelector").show();
      $('#frequencyType').attr('name', 'properties[frequencytype]');
      $("#frequencyName").attr('name', 'properties[frequencyname]');
    } else {
      $("#autoorderFrequencySelector").hide();
      $('#frequencyType').attr('name', '');
      $("#frequencyName").attr('name', '');
    }
  });
  $("#autorderFrequency").on("change", function(){
     var typeId = $(this).val();
     var name = $("#autorderFrequency option:selected").text();
      $("#frequencyType").val(typeId);
      $("#frequencyName").val(name);
  });
}
function addToCart(button){
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $(button).closest('form').serialize(),
    success: function(){
        window.location = "/cart"; 
      }
   });
}
function Checkforenrollmentkit(button) {
  var hasPack = false;
  var count = 0
  return fetch('/cart.js')
    .then(function (response) {
        return response.json();
    })
    .then(function (json) {
      for(let i = 0; i < json.items.length; i++) {
        let obj = json.items[i];
        if(obj.properties.ordertype == "enrollmentpack"){
          hasPack = true;
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                quantity: 0,
                id: obj.id
            },
            success: function (data){
              addToCart(button);
            }
          });
        }
      }
      if(!hasPack) {
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function(){
            addToCart(button);
          },
          dataType: 'json'
        });
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
}
function clearCart(){
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function(){
      window.location = window.location;
    },
    dataType: 'json'
  });
}
//End Exigo Checkout Functions

//start affiliate points
function getPoints(callBack){
  $.ajax({
    url: apiUrl + '/api/Affiliate/GetCustomerPointaccountBalance?token=' + getLoginCookie() + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function getAllAffiliateRewards(callBack){
  $.ajax({
    url: apiUrl + '/api/Affiliate/GetAffiliateRewards?token=' + getLoginCookie() + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function createAffiliateReward(callBack, amount){
  var url = url = apiUrl + '/api/Affiliate/CreatePointRedemptionCode?amount=' + amount + '&token=' + getLoginCookie() + '&shopUrl=' + shopUrl + "&useGraphQL=true";
  $.ajax({
    url: url,
    type: "POST",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
function getPointAccountHistory(callBack){
  console.log("GetHistory");
  $.ajax({
    url: apiUrl + '/api/Affiliate/GetPointAccountHistory?token=' + getLoginCookie() + '&shopUrl=' + shopUrl,
    type: "GET",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    success: function(response){
      callBack(response);
    }
  });
}
//end affiliate points
